class MedicationsController {
  /* @ngInject */
  constructor($stateParams, $http, Endpoints) {
    Object.assign(this, {
      $params: $stateParams,
      $http,
      Endpoints
    });
    this.getMedications();
  }

  getMedications() {
    this.loading = true;
    this.$http.get(this.Endpoints.plans.medications.replace(':orderline_id', this.$params.id), {
      loadingText: 'Loading Medications'
    }).then(({
      data
    }) => {
      Object.assign(this, data);

      _.each(this.medications, med => {
        med.page = med.page.replace('com.polkadoc.ocp:/', '');
      });
    }).catch(() => this.error = true).finally(() => this.loading = false);
  }

}

MedicationsController.$inject = ["$stateParams", "$http", "Endpoints"];
angular.module('pims').controller('MedicationsController', MedicationsController);